module.exports = __webpack_public_path__ + "assets/google-pagespeed.64e2c86b.svg";